<template>

    <h5>Contract Documents</h5>

    <div class="saveNewBtnContainer">
        <span class="subHeaderFont">Save New Contract Document:</span>
        <div @click="ShowNewDocumentForm" class="material-icons forIconNewRecord text-success" data-tooltip="tooltip"
        title="Save a new Document">
        add_card
        </div>
    </div>
    

    <form>
        <div class="newContractDocFormContainer card card-body collapse" data-collapsed="true" id="newContractDocCardCollapse">

            <div class="newContractDocFormDocTypeDropdownContainer">
                <DropdownInput input-id="documentTypeId" label-text="Document Type:" :input-v-model="this.newDocumentType" object-key="documentTypeId" :option-list="this.docTypeDropdownValues" @update-form="UpdateForm" ></DropdownInput>
            </div>
            
            <div class="uploaderAndLabelContainer">
                <label for="fileInput" class="form-label">Upload File</label>
                <input id="fileInput" type="file" @change="FileChanged">
            </div>
            
            <div class="btnContainer">
                <button type="button" @click="SaveDocument" class="btn btn-danger" data-toggle="collapse" data-target="#newContractDocCardCollapse">Cancel</button>
            <button type="button" @click="SaveDocument" class="btn btn-primary">Save</button>
            </div>
            

        </div>
        
    </form>

    <DataTable v-if="this.getAllContractDocsUrl" 
    :data-url="this.getAllContractDocsUrl" 
    :column-list-d-b="this.contractDocColumns"
    :column-list-pretty="this.contractDocColumnsPretty" 
    column-name-id="documentId" 
    :center-column-indexes="[2]"
    :date-column-indexes="[2]" 
    :order-column-index="0" 
    rows-per-page="-1" 
    :show-search="false" 
    :show-paging="false"
    plural-data-name="contract documents"
    order-direction="asc" 
    ref="contractDocumentListTable" 
    :show-action-column="false"
    > 

        <template v-slot:extraColumnHeaders>

            <th>
                Document
            </th>

            <th>
                Upload Date
            </th>

            <th>
                Updated By
            </th>

        </template>

        <template #extraColumns="extraColumnRowData">

            <td :data-sort="extraColumnRowData.documentName">
                <a href="#" @click="DocumentNameClicked(extraColumnRowData)">{{ extraColumnRowData.documentName }}</a>
            </td>

            <td :data-sort="extraColumnRowData.uploadDate">
                {{ extraColumnRowData.uploadDatePretty }}
            </td>

            <td :data-sort="extraColumnRowData.uploadByUserEmail">
                <a :href="'mailto:'+extraColumnRowData.uploadByUserEmail">{{ extraColumnRowData.uploadByUserEmail }}</a>
            </td>

        </template>

    </DataTable>
    <a :href="downloadHardcodeLink" ref="downloadClick" download class="dNone">download the doc</a>
  </template> 
    
  <script> 
    
    import { store } from "@/store/store.js";
    import $ from "jquery";
    import {ajaxGetAndReturn} from "@/components/helpers/utilities.js";
    import axios from "axios";
    import DataTable from "@/components/dataSupport/DataTable.vue";
    import DropdownInput from "@/components/formComponents/DropdownInput.vue";

    export default {
      name: "ContractDocuments",
      components: {
        DataTable, DropdownInput
      }, 
      data(){
        return{
          isMounted : false,
          contractIdToLoad: null,
          getAllContractDocsUrl:null,
          contractDocColumns: ['documentTypeName'],
          contractDocColumnsPretty: ['Type'],
          uploadFile: null,
          returnedFileObject:null,
          newDocumentType:1,
          downloadHardcodeLink:"#"
        }
      },
      props: {
        // Data that is set by the parent component in the <componentTag> in lowercase with dashes where uppercase appear in
        // the prop name. EX: columnListPretty is set as <componentTag column-list-pretty=""> see more prop examples on other components
        /*
        columnListDB: Array,
        columnListPretty: Array,
        dataUrl: String,
        */
      },
      async created(){ // called BEFORE rendering (load data here)

        ajaxGetAndReturn(store.webAPIUrl + "documentType/getDropdown", (result) =>{
            this.docTypeDropdownValues = result; 
        });
        
      },
      mounted() { // called afer rendering
        this.isMounted = true; 
      },
  
      methods:{
        async LoadData(contractId){
            this.getAllContractDocsUrl = store.webAPIUrl + "contractDocumentListDTO/" + contractId;
            this.contractIdToLoad = contractId; 

            console.log("hitting load data for contracts doc component"); 
              $("#newContractDocCardCollapse").collapse('hide');
              console.log("contract document should be hidden");

           if(this.$refs.contractDocumentListTable != null){
            console.log("geting contracts doc for contract id: ", this.contractIdToLoad);
            this.$refs.contractDocumentListTable.LoadDataAndInitializeTable(this.getAllContractDocsUrl);
           }
                
        },
        ClickedDeleteContractDocument(dataRow){
            console.log(dataRow.documentGuid); 
        },
        DocumentNameClicked(dataRow){
            console.log(dataRow); 
            var lastIndexOfPeriod = dataRow.documentName.lastIndexOf(".");
            var extension = dataRow.documentName.slice(lastIndexOfPeriod +1);
            //console.log(extension);
            var url = store.webAPIUrl + "file/downloadDocument/" + dataRow.documentGuid + "/." + extension;
            
             $.ajax({
                method: "GET",
                contentType: "application/json; charset=utf-8",
                url: url,
                xhrFields: {
                    withCredentials: true,
                    responseType:"blob"
                },
                success: (result) => {
                    console.log("successfully grabed doc");
                    var fileURL = URL.createObjectURL(result);

                    var docLinkElement = this.$refs.downloadClick;
                    docLinkElement.href = fileURL; 
                    docLinkElement.download = dataRow.documentName;

                    this.$refs.downloadClick.click(); 
                    this.downloadHardcodeLink = "";
                    docLinkElement.href = ""; 
                },
            });
            //DownloadDocument/{docname}/{extension}
        },
        FileChanged(e){
            this.uploadFile = e.target.files[0];
        },
        UpdateForm(objKey, modelData){
            //console.log("dropdowkksajdlfk")
            objKey;
            this.newDocumentType = modelData;
        },
        
        SaveDocument(){
            console.log("save documentClicked", this.uploadFile);
            var actionUrl = store.webAPIUrl + "File/uploadFileObject";
            var formData = new FormData(); 
            formData.append("file", this.uploadFile, this.uploadFile.name);
            formData.append("upload_file", true); 
            $.ajax({
                method: "POST",
                processData:false,
                contentType: false,
                dataType: "json",
                url: actionUrl,
                data: formData,
                success: (result) => {
                    console.log(result);
                    this.returnedFileObject = result; 
                    this.SaveDocumentInfoToDB();
                    //this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                },
            });

            
        },
        SaveDocumentInfoToDB(){
            console.log(store);
            var actionUrl = store.webAPIUrl + "File/SaveContractFileToDatabase"; 
            var contractDocumentObj =  {
                contractId : this.contractIdToLoad,
                document: {
                    documentGuid: this.returnedFileObject.baseFileName,
                    documentName: this.uploadFile.name,
                    documentTypeId:this.newDocumentType, 
                    documentMimeType:this.returnedFileObject.fileExtension, 
                },
                uploadBy: store.authenticatedUser.userProfileId,
            };

            console.log(contractDocumentObj);

            $.ajax({
                method: "POST",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: actionUrl,
                data: JSON.stringify(contractDocumentObj),
                success: (result) => {
                    console.log(result);
                    this.$refs.contractDocumentListTable.LoadDataAndInitializeTable(this.getAllContractDocsUrl);
                },
            });
        },
        ShowNewDocumentForm(){
            $("#newContractDocCardCollapse").collapse('show');
            console.log("toggel document upload component");
        }
      },
      unmounted(){ //called when the page is left or the component is destroyed
  
        //console.log("force update user contracts table"); 
        this.$forceUpdate();
      }
    }
  </script>
    
  <style scoped>
  .newContractDocFormContainer{
    display:flex;
    align-items: end;
    justify-items: center;
    justify-content: space-evenly;
    flex-direction: row;
  }
  .btnContainer{
    display:flex;
  }
  .saveNewBtnContainer{
    display:flex;
  }
  .dNone{
display:none;
  }
  </style>
  